import {
  getEmailSubscription as publicGetEmailSubscription,
  queryEmailSubscriptions as publicQueryEmailSubscriptions,
  upsertEmailSubscription as publicUpsertEmailSubscription,
  bulkUpsertEmailSubscription as publicBulkUpsertEmailSubscription,
  generateUnsubscribeLink as publicGenerateUnsubscribeLink,
} from './emailsubscriptions-v1-emailsubscription-email-subscriptions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onEmailsubscriptionEmailSubscriptionChanged as publicOnEmailsubscriptionEmailSubscriptionChanged } from './emailsubscriptions-v1-emailsubscription-email-subscriptions.public.js';

/** @internal */
export const getEmailSubscription: MaybeContext<
  BuildRESTFunction<typeof publicGetEmailSubscription> &
    typeof publicGetEmailSubscription
> = /*#__PURE__*/ createRESTModule(publicGetEmailSubscription);
export const queryEmailSubscriptions: MaybeContext<
  BuildRESTFunction<typeof publicQueryEmailSubscriptions> &
    typeof publicQueryEmailSubscriptions
> = /*#__PURE__*/ createRESTModule(publicQueryEmailSubscriptions);
export const upsertEmailSubscription: MaybeContext<
  BuildRESTFunction<typeof publicUpsertEmailSubscription> &
    typeof publicUpsertEmailSubscription
> = /*#__PURE__*/ createRESTModule(publicUpsertEmailSubscription);
export const bulkUpsertEmailSubscription: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpsertEmailSubscription> &
    typeof publicBulkUpsertEmailSubscription
> = /*#__PURE__*/ createRESTModule(publicBulkUpsertEmailSubscription);
export const generateUnsubscribeLink: MaybeContext<
  BuildRESTFunction<typeof publicGenerateUnsubscribeLink> &
    typeof publicGenerateUnsubscribeLink
> = /*#__PURE__*/ createRESTModule(publicGenerateUnsubscribeLink);
/** */
export const onEmailsubscriptionEmailSubscriptionChanged: BuildEventDefinition<
  typeof publicOnEmailsubscriptionEmailSubscriptionChanged
> &
  typeof publicOnEmailsubscriptionEmailSubscriptionChanged = createEventModule(
  publicOnEmailsubscriptionEmailSubscriptionChanged
);

export {
  SubscriptionEnumStatus,
  Status,
  WebhookIdentityType,
} from './emailsubscriptions-v1-emailsubscription-email-subscriptions.universal.js';
export {
  EmailSubscription,
  EmailSubscriptionChanged,
  GetEmailSubscriptionRequest,
  GetEmailSubscriptionResponse,
  UpdateEmailSubscriptionRequest,
  UpdateEmailSubscriptionResponse,
  QueryEmailSubscriptionsRequest,
  Paging,
  QueryEmailSubscriptionsResponse,
  PagingMetadata,
  UpsertEmailSubscriptionRequest,
  UpsertEmailSubscriptionResponse,
  BulkUpsertEmailSubscriptionRequest,
  BulkUpsertEmailSubscriptionResponse,
  BulkUpsertEmailSubscriptionResult,
  Error,
  Metadata,
  GenerateUnsubscribeLinkRequest,
  GenerateUnsubscribeLinkResponse,
  RenderUnsubscribePageRequest,
  RawHttpResponse,
  HeadersEntry,
  ConfirmUnsubscribeActionRequest,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  V1RenderUnsubscribePageRequest,
  V1ConfirmUnsubscribeActionRequest,
  BaseEventMetadata,
  EmailsubscriptionEmailSubscriptionChangedEnvelope,
  QueryEmailSubscriptionsOptions,
  UpsertEmailSubscriptionOptions,
  GenerateUnsubscribeLinkOptions,
} from './emailsubscriptions-v1-emailsubscription-email-subscriptions.universal.js';
export {
  SubscriptionEnumStatusWithLiterals,
  StatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './emailsubscriptions-v1-emailsubscription-email-subscriptions.universal.js';
